import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Thumbs, EffectFade } from 'swiper/modules';

const swiperElements = Array.from(document.querySelectorAll('.swiper[data-config]'));

const initSwiper = (element) => {
    const swiper = new Swiper(element, {
        modules: [Navigation, Pagination, Autoplay, Thumbs, EffectFade],
        grabCursor: true,
        navigation: {
            nextEl: `#${element.id}-next`,
            prevEl: `#${element.id}-prev`,
        },
        pagination: {
            el: `#${element.id}-pagination`,
            clickable: true,
        },
        ...(JSON.parse(element.dataset?.config || '{}')),
        ...(element.dataset?.thumbs ? {
            thumbs: {
                swiper: initSwiper(document.getElementById(element.dataset.thumbs)),
            },
        } : {}),
    });

    return swiper;
};

swiperElements.forEach((element) => {
    const swiper = initSwiper(element);

    if (element.dataset?.thumbs) {
        const thumbsElement = document.getElementById(element.dataset.thumbs);
        const thumbButtons = thumbsElement?.querySelectorAll('.swiper-slide');

        thumbButtons?.forEach((button, index) => {
            button.addEventListener('click', () => {
                swiper.slideTo(index);
            });
        });
    }
});
